import { render, staticRenderFns } from "./TermsOfServiceNL.vue?vue&type=template&id=4c981650&scoped=true"
import script from "./TermsOfServiceNL.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceNL.vue?vue&type=script&lang=js"
import style0 from "./TermsOfServiceNL.vue?vue&type=style&index=0&id=4c981650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c981650",
  null
  
)

export default component.exports